export const TEAM_MEMBERS = [
  {
    name: 'Prabhat Kumar',
    role: 'Founder, CEO / CTO',
    image: 'https://appthing-website.s3.ap-south-1.amazonaws.com/prabhat.png',
    description:
      'Prabhat is a visionary leader with over 7+ years of experience driving technology innovation, product excellence, and strategic business growth. His ability to blend technical expertise with forward-thinking strategy makes him instrumental in shaping solutions that deliver meaningful impact and long-term value.',
    socialLinks: [
      {
        icon: 'bx bxl-linkedin',
        url: 'https://www.linkedin.com/in/prabhat-jaiswal-b9a57537b/',
      },
    ],
  },
  {
    name: 'Gyan Prakash Ranjan',
    role: 'Head of Product',
    image: 'https://appthing-website.s3.ap-south-1.amazonaws.com/gyan.jpeg',
    description:
      'As Head of Product, Gyan drives the product vision with clarity and purpose, ensuring every solution aligns with customer needs and market opportunities. He leads with innovation and insight, transforming ideas into impactful products that elevate the company’s competitive edge.',
    socialLinks: [
      {
        icon: 'bx bxl-linkedin',
        url: 'https://www.linkedin.com/in/gyan/',
      },
    ],
  },
  {
    name: 'Vivek Behera',
    role: 'Head of Engineering',
    image: 'https://appthing-website.s3.ap-south-1.amazonaws.com/vivek.jpeg',
    description:
      'Vivek is passionate about solving complex technical challenges and architecting scalable, high-performance software solutions that truly empower users. With a strong focus on clean engineering, innovation, and user-centric thinking, he consistently transforms complex ideas into reliable and impactful digital products.',
    socialLinks: [
      {
        icon: 'bx bxl-linkedin',
        url: 'https://www.linkedin.com/in/vivek-behera-75876aaa/',
      },
    ],
  },
  {
    name: 'Rakesh Patel',
    role: 'Head of Design',
    image: 'https://appthing-website.s3.ap-south-1.amazonaws.com/rakesh.png',
    description:
      'Our design expert blend creativity with user-focused strategy, crafting intuitive interfaces that elevate every digital experience. With a deep understanding of aesthetics, usability, and brand identity, they transform ideas into visually compelling and meaningful designs.',
    socialLinks: [
      {
        icon: 'bx bxl-linkedin',
        url: 'https://www.linkedin.com/in/rakesh-patel-6b911090/',
      },
    ],
  },
  {
    name: 'Sudhist Kumar',
    role: 'Lead Software Engineer',
    image: 'https://appthing-website.s3.ap-south-1.amazonaws.com/sudhist.png',
    description:
      'Sudhist is passionate about solving complex problems and building scalable software solutions that empower users. He is a skilled developer focused on delivering high-quality code and optimizing application performance.',
    socialLinks: [
      {
        icon: 'bx bxl-linkedin',
        url: 'https://www.linkedin.com/in/sudhist-kumar/',
      },
    ],
  },
];
